export const MainMapControllerSymbol = Symbol('MAIN_MAP_CONTROLLER')
